import React from "react";

// Crece logo — stylized "C" with sprout (Crece = "to grow" in Spanish)
// Sizes: sm (28px), md (36px), lg (48px). Use `theme="dark"` on light bg, "light" on dark bg.
export function CreceLogo({ size = "md", theme = "dark", className = "" }) {
  const px = size === "sm" ? 28 : size === "lg" ? 48 : 36;
  const bg = theme === "dark" ? "#064E3B" : "#FBBF24";
  const fg = theme === "dark" ? "#FBBF24" : "#064E3B";

  return (
    <svg
      className={className}
      width={px}
      height={px}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Crece logo"
    >
      {/* Rounded square background */}
      <rect x="0" y="0" width="48" height="48" rx="14" fill={bg} />
      {/* Stylized C — arc opening right */}
      <path
        d="M34 17.5C32.2 14.4 28.8 12.5 25 12.5C19.2 12.5 14.5 17.4 14.5 23.5C14.5 29.6 19.2 34.5 25 34.5C28.8 34.5 32.2 32.6 34 29.5"
        stroke={fg}
        strokeWidth="4.5"
        strokeLinecap="round"
      />
      {/* Sprout leaf at top of C — represents 'grow' */}
      <path
        d="M30 11.5C30.5 9 32.5 7.5 34.5 7.5C34.5 10 33 12 30.5 12.2"
        fill={fg}
      />
      <circle cx="34" cy="23.5" r="2.2" fill={fg} />
    </svg>
  );
}

export function CreceWordmark({ theme = "dark", size = "md" }) {
  const textSize = size === "sm" ? "text-base" : size === "lg" ? "text-2xl" : "text-xl";
  const color = theme === "dark" ? "text-stone-900" : "text-stone-50";
  return (
    <div className="flex items-center gap-2">
      <CreceLogo size={size} theme={theme} />
      <span className={`font-display font-black tracking-tight ${textSize} ${color}`}>Crece</span>
    </div>
  );
}
